import React from "react";

export const CompleteIcon = ({ ...props }) => {
  return (
    <svg width={10} height={8} viewBox="0 0 10 8" fill="none" {...props}>
      <path
        d="M9 1L3.5 6.5 1 4"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
